(ns dashboard.events
  (:require
   [very.re-frame.core :as rf]
   [graphql.core :as qu]))

(defn load-flow []
  {:first-dispatch [:fetch-dashboard]
   :rules [{:when :seen-any-of? :events [:dashboard-fetched :dashboard-fetch-errored] :dispatch [:loader/hide] :halt? true}]})

(rf/reg-event-fx
 :boot-dashboard
 (fn [cfx]
   {:db (update (:db cfx) :dashboard assoc :context :dashboarding)
    :dispatch [:loader/show]
    :async-flow (load-flow)}))

(rf/reg-event-fx
 :fetch-dashboard
 (fn [cfx]
   {:graphql {:gql (qu/fetch-client-dashboard)
              :success [:dashboard-fetched]
              :error [:dashboard-fetch-errored]
              :cancellable? true}
    :entity {:type :priorities
             :op :get}}))

(rf/reg-event-fx
 :dashboard/update-priorities
 (fn [cfx [priorities]]
   {:entity {:type :priorities
             :op :patch
             :data priorities
             :success [:dashboard/priorities-updated]
             :error [:dashboard/priorities-updated]}}))

(rf/reg-event-fx
 :dashboard/priorities-updated
 (fn [cfx]
   {:dispatch-n [[:boot-dashboard]
                 [:success-message "You've successfully update your financial priorities"]
                 [:financial-priorities/reset]]
    :db (assoc-in (:db cfx) [:dashboard :context] :dashboarding)}))

(rf/reg-event-fx
 :dashboard/edit-priorities
 (fn [cfx]
   {:prevent-events {:register :dashboard/prevent
                     :catch-these-events #{:navigate-to-context
                                           :router/route-to-path
                                           :dashboard/change-context}
                     :and-instead-dispatch [:dashboard/leave-edit-priorities]}
    :db (assoc-in (:db cfx) [:dashboard :context] :editing-priorities)}))

(rf/reg-event-db
 :dashboard/change-context
 (fn [db [ctx]]
   (assoc-in db [:dashboard :context] ctx)))

(rf/reg-event-fx
 :dashboard/leave-edit-priorities
 (fn [cfx]
   {:prevent-events {:unregister :dashboard/prevent}
    :dispatch [:financial-priorities/reset]}))

(defn- ingest-dashboard [db data]
  (-> db
      (assoc :client-accounts (get-in data [:client :accounts]))
      (assoc-in [:dashboard :advisor] (get-in data [:client :advisor]))
      (assoc-in [:dashboard :totals]
                {:net-worth (get-in data [:client :net-worth])
                 :assets (get-in data [:client :total-assets])
                 :liabilities (get-in data [:client :total-liabilities])})
      (assoc-in [:dashboard :accounts-net]
                {:net (get-in data [:client :accounts :total-value])
                 :internal-net (get-in data [:client :accounts :internal :total-value])
                 :external-net (get-in data [:client :accounts :external :total-value])})
      (assoc-in [:dashboard :todo-list] (get-in data [:client :cases]))))

(rf/reg-event-db
 :dashboard-fetched
 (fn [db [data]]
   (ingest-dashboard db data)))

(rf/reg-event-db
 :dashboard-fetch-errored
 (fn [db [data]]
   (ingest-dashboard db (:data data))))

(rf/reg-sub
 :dashboard/advisor
 (fn [db]
   (get-in db [:dashboard :advisor])))

(rf/reg-sub
 :dashboard/context
 (fn [db]
   (get-in db [:dashboard :context])))

(rf/reg-sub
 :dashboard/totals
 (comp :totals :dashboard))

(rf/reg-sub
 :dashboard/accounts-net
 (comp :accounts-net :dashboard))

(rf/reg-sub
 :dashboard/todos
 (comp :todo-list :dashboard))
